import logo from './logo.svg';
import './App.css';
import AllRoutes from './AllRoutes';
import { Provider } from 'react-redux';
import { AuthProvider } from './Helper/Context';
import { ToastContainer } from 'react-toastify';
import store from "./Redux/Store";

function App() {
  return (
    <>
     <Provider store={store}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <AuthProvider>
        <AllRoutes />
        </AuthProvider>
      </Provider>
    </>
  );
}

export default App;
